import axios from 'axios'
import i18n from "../i18n";
import vuex from '../store'

/**
 * Auth routes
 */
export const axiosAuth = {
  get: () => axios.get(`/auth/check`),
  auth: async ({email, password}) => await axios.post(`/auth/login`, {email, password}),
  register: async (data) => await axios.post(`/auth/register`, data),
  sendVerification: async () => await axios.post(`/auth/verify-email/send`),
  verifyMyEmail: async ({id, hash}) => await axios.post(`/auth/verify-email/verify/${id}/${hash}`),
  forgotPassword: async ({email}) => await axios.post(`/auth/forgot-password`, {email}),
  forgotPasswordReset: async (data) => await axios.post(`/auth/forgot-password/reset`, data),
  logout: async () => await axios.post(`/auth/logout`),
}

/*** Dashboard routes */
let dashboard_api_group = `/dashboard`
export const axiosDashboardUrl = {
  blocks: `${dashboard_api_group}/blocks`,
}
export const axiosDashboard = {
  fetchBlocksData: (params) => axios.get(axiosDashboardUrl.blocks, {params}),
}

/*** Public holiday routes */
let public_holiday_api_group = `/public-holiday`
export const axiosPublicHolidayUrl = {
  list: `${public_holiday_api_group}/bet-by-year`,
  createUpdate: `${public_holiday_api_group}/create-update`,
}
export const axiosPublicHoliday = {
  fetchList: (params) => axios.get(axiosPublicHolidayUrl.list, {params}),
  createUpdate: (data) => axios.post(axiosPublicHolidayUrl.createUpdate, data),
}

/*** User routes */
let user_api_group = `/user`
export const axiosUserUrl = {
  dailyReport: `${user_api_group}/daily-report`,
  hasDailyReport: `${user_api_group}/has-daily-report`,
  createUpdateReport: `${user_api_group}/daily-report`,
  getMyVacations: `${user_api_group}/my-vacations`,
  getMyFutureVacations: `${user_api_group}/my-future-vacations`,
  getMyMonthlyReport: `${user_api_group}/monthly-report`,
  sendToManager: `${user_api_group}/verify-vacations`,
}
export const axiosUser = {
  fetchHasTodayReport: (params) => axios.get(axiosUserUrl.hasDailyReport, {params}),
  fetchDailyReport: (params) => axios.get(axiosUserUrl.dailyReport, {params}),
  createUpdateReport: (data) => axios.post(axiosUserUrl.createUpdateReport, data),
  getMyVacations: (params) => axios.get(axiosUserUrl.getMyVacations, {params}),
  getMyFutureVacations: (params) => axios.get(axiosUserUrl.getMyFutureVacations, {params}),
  getMyMonthlyReport: (params) => axios.get(axiosUserUrl.getMyMonthlyReport, {params}),
  updateMyVacations: (data) => axios.post(axiosUserUrl.getMyVacations, data),
  sendToManager: (data) => axios.post(axiosUserUrl.sendToManager, data),
}

/*** Manager routes */
let manager_api_group = `/manager`
export const axiosManagerUrl = {
  fetchEmployees: `${manager_api_group}/employees`,
  approveVacationByDates: `${manager_api_group}/submit-vacations`,
}
export const axiosManager = {
  fetchEmployees: (params) => axios.get(axiosManagerUrl.fetchEmployees, {params}),
  approveVacationByDates: (data) => axios.post(axiosManagerUrl.approveVacationByDates, data),
}

/**
 * Users routes
 */
let users_api_group = `/users`
export const axiosUsersUrl = {
  list: `${users_api_group}`,
  filters: `${users_api_group}/filters`,
  roles: `${users_api_group}/roles`,
  beltBenefits: `${users_api_group}/belts`,
  get: (id) => `${users_api_group}/${id}`,
  login_by_id: `${users_api_group}/login-by-id`,
  createUpdate: `${users_api_group}/create-update`,
  approveAccount: `${users_api_group}/approve-account`,
  createUpdateAvailableVacationDays: `${users_api_group}/create-update-available-vacation-days`,
  active: `${users_api_group}/update-active`,
  delete: (id) => `${users_api_group}/delete/${id}`,
}
export const axiosUsers = {
  list: (params) => axios.get(axiosUsersUrl.list, {params}),
  filters: () => axios.get(axiosUsersUrl.filters),
  roles: () => axios.get(axiosUsersUrl.roles),
  benefits: () => axios.get(axiosUsersUrl.beltBenefits),
  get: (id) => axios.get(axiosUsersUrl.get(id)),
  login_by_id: ({id}) => axios.post(axiosUsersUrl.login_by_id, ({id})),
  createUpdate: (data) => axios.post(axiosUsersUrl.createUpdate, data),
  approveAccount: () => axios.post(axiosUsersUrl.approveAccount),
  createUpdateAvailableVacationDays: (data) => axios.post(axiosUsersUrl.createUpdateAvailableVacationDays, data),
  updateActive: (data) => axios.post(axiosUsersUrl.active, data),
  delete: (id) => axios.delete(axiosUsersUrl.delete(id)),
}

/**
 * Articles routes
 */
let articles_api_group = `/article`
export const axiosArticlesUrl = {
  list: `${articles_api_group}`,
  get: (id) => `${articles_api_group}/${id}`,
  uploadImage: `${articles_api_group}/image/upload`,
  imageDelete: `${articles_api_group}/image/delete`,
  categories: () => `${articles_api_group}/categories`,
  category: (id) => `${articles_api_group}/categories/${id}`,
  setPublished: `${articles_api_group}/set-published`,
  update: `${articles_api_group}/update`,
  updateCategory: `${articles_api_group}/categories/update`,
  unread: () => `${articles_api_group}/unread`,
  delete: (id) => `${articles_api_group}/delete/${id}`,
  deleteCategory: (id) => `${articles_api_group}/categories/delete/${id}`
}
export const axiosArticles = {
  list: (params) => axios.get(axiosArticlesUrl.list, {params}),
  get: (id) => axios.get(axiosArticlesUrl.get(id)),
  getCategories: () => axios.get(axiosArticlesUrl.categories()),
  getCategory: (id) => axios.get(axiosArticlesUrl.category(id)),
  upload: (data) => axios.post(axiosArticlesUrl.uploadImage, data),
  setPublished: (data) => axios.post(axiosArticlesUrl.setPublished, data),
  deleteImage: (data) => axios.post(axiosArticlesUrl.imageDelete, data),
  getDashboardArticles: () => axios.get(axiosArticlesUrl.unread()),
  updateArticle: (data) => axios.post(axiosArticlesUrl.update, data),
  updateCategory: (data) => axios.post(axiosArticlesUrl.updateCategory, data),
  delete: (id) => axios.delete(axiosArticlesUrl.delete(id)),
  deleteCategory: (id) => axios.delete(axiosArticlesUrl.deleteCategory(id)),
}

/**
 * Documents routes
 */
let documents_api_group = `/document`
export const axiosDocumentsUrl = {
  list: `${documents_api_group}`,
  get: (id) => `${documents_api_group}/${id}`,
  update: `${documents_api_group}/update`,
  delete: (id) => `${documents_api_group}/delete/${id}`,
  categories: () => `${documents_api_group}/categories`,
  category: (id) => `${documents_api_group}/categories/${id}`,
  updateCategory: `${documents_api_group}/categories/update`,
  deleteCategory: (id) => `${documents_api_group}/categories/delete/${id}`,
  uploadFile: `${documents_api_group}/file/upload`,
  deleteFile: `${documents_api_group}/file/delete`,
}
export const axiosDocuments = {
  list: (params) => axios.get(axiosDocumentsUrl.list, {params}),
  get: (id) => axios.get(axiosDocumentsUrl.get(id)),
  delete: (id) => axios.delete(axiosDocumentsUrl.delete(id)),
  updateDocument: (data) => axios.post(axiosDocumentsUrl.update, data),
  getCategories: () => axios.get(axiosDocumentsUrl.categories()),
  getCategory: (id) => axios.get(axiosDocumentsUrl.category(id)),
  updateCategory: (data) => axios.post(axiosDocumentsUrl.updateCategory, data),
  deleteCategory: (id) => axios.delete(axiosDocumentsUrl.deleteCategory(id)),
  uploadFile: (data) => axios.post(axiosDocumentsUrl.uploadFile, data),
  deleteFile: (data) => axios.post(axiosDocumentsUrl.deleteFile, data),
}
/**
 * Statistic routes
 */
let statistic_api_group = `/statistic`
export const axiosStatisticUrl = {
  site: `${statistic_api_group}/site`,
  working: `${statistic_api_group}/working`,
  vacations: `${statistic_api_group}/vacations`,
}
export const axiosSiteStatus = {
  site: (params) => axios.get(axiosStatisticUrl.site, {params}),
  working: (params) => axios.get(axiosStatisticUrl.working, {params}),
  vacations: (params) => axios.get(axiosStatisticUrl.vacations, {params}),
}
/**
 * Report routes
 */
let reports_api_group = `/report`
export const axiosReportUrl = {
  list: `${reports_api_group}`,
  fact: `${reports_api_group}/fact`,
  get: (id) => `${reports_api_group}/${id}`,
  getWithUser: (id) => `${reports_api_group}/user/${id}`,
}
export const axiosReport = {
  list: (params) => axios.get(axiosReportUrl.list, {params}),
  fact: (params) => axios.get(axiosReportUrl.fact, {params}),
  get: (id) => axios.get(axiosReportUrl.get(id)),
  reportWithUser: (id)=> axios.get(axiosReportUrl.getWithUser(id))
}

/**
 * Belt routes
 */
let belts_api_group = `/belt`
export const axiosBeltUrl = {
  list: `${belts_api_group}/list`,
  package: (id) => `${belts_api_group}/belt-package/${id}`,
  belt: (id) => `${belts_api_group}/belt-benefit/${id}`,
  updatePackage: `${belts_api_group}/update-package`,
  updateBenefit: `${belts_api_group}/update-benefit`,
}
export const axiosBelts = {
  list: (params) => axios.get(axiosBeltUrl.list, {params}),
  package: (id) => axios.get(axiosBeltUrl.package(id)),
  belt: (id) => axios.get(axiosBeltUrl.belt(id)),
  createUpdatePackage: (data) => axios.post(axiosBeltUrl.updatePackage, data),
  createUpdateBenefit: (data) => axios.post(axiosBeltUrl.updateBenefit, data),
}
let belts_cookies_api_group = `/belt/cookie`
export const axiosBeltCookieUrl = {
  list: `${belts_cookies_api_group}/list`,
  pureList: `${belts_cookies_api_group}/pure-list`,
  item: (id) => `${belts_cookies_api_group}/${id}`,
  createUpdate: `${belts_cookies_api_group}/create-update`
}
export const axiosBeltsCookie = {
  list: (params) => axios.get(axiosBeltCookieUrl.list, {params}),
  pureList: (params) => axios.get(axiosBeltCookieUrl.pureList, {params}),
  item: (id) => axios.get(axiosBeltCookieUrl.item(id)),
  createUpdate: (data) => axios.post(axiosBeltCookieUrl.createUpdate, data),
}

/**
 * Export routes
 */
let exports_api_group = `/export`
export const axiosExportUrl = {
  list: `${exports_api_group}`,
  path: `${exports_api_group}/path`,
  generate_daily:  `${exports_api_group}/generate-daily`,
  generate_site_status:  `${exports_api_group}/generate-site-status`,
  download:  `${exports_api_group}/download`,
  delete:  `${exports_api_group}/delete`,
}
export const axiosExport = {
  list: (params) => axios.get(axiosExportUrl.list, {params}),
  path: (params) => axios.get(axiosExportUrl.path, {params}),
  generateDaily: (data) => axios.post(axiosExportUrl.generate_daily, data),
  generateSiteStatus: (data) => axios.post(axiosExportUrl.generate_site_status, data),
  download: (params, responseType, headers) => axios.get(axiosExportUrl.download, {params, responseType, headers}),
  delete: (data) => axios.post(axiosExportUrl.delete, data),
}
/**
 * Committees routes
 */
let committees_api_group = `/committee`
export const axiosCommitteesUrl = {
  list: `${committees_api_group}`,
  pureList: `${committees_api_group}/pure-list`,
  get: (id) => `${committees_api_group}/${id}`,
  createUpdate: `${committees_api_group}/create-update`,
  delete: (id) => `${committees_api_group}/delete/${id}`,
}
export const axiosCommittees = {
  list: (params) => axios.get(axiosCommitteesUrl.list, {params}),
  pureList: (params) => axios.get(axiosCommitteesUrl.pureList, {params}),
  get: (id) => axios.get(axiosCommitteesUrl.get(id)),
  createUpdate: (data) => axios.post(axiosCommitteesUrl.createUpdate, data),
  delete: (id) => axios.delete(axiosCommitteesUrl.delete(id)),
}

/**
 * Company equipments routes
 */
let company_equipment_api_group = `/company-equipment`
export const axiosCompanyEquipmentUrl = {
  list: `${company_equipment_api_group}`,
  get: (id) => `${company_equipment_api_group}/${id}`,
  createUpdate: `${company_equipment_api_group}/create-update`,
  delete: (id) => `${company_equipment_api_group}/delete/${id}`,
}
export const axiosCompanyEquipment = {
  list: (params) => axios.get(axiosCompanyEquipmentUrl.list, {params}),
  get: (id) => axios.get(axiosCompanyEquipmentUrl.get(id)),
  createUpdate: (data) => axios.post(axiosCompanyEquipmentUrl.createUpdate, data),
  delete: (id) => axios.delete(axiosCompanyEquipmentUrl.delete(id)),
}

/**
 * User equipments routes
 */
let users_equipment_api_group = `/user-equipment`

export const axiosUserEquipmentUrl = {
  get: (id) => `${users_equipment_api_group}/${id}`,
  createUpdate: `${users_equipment_api_group}/create-update`,
  delete: (id) => `${users_equipment_api_group}/delete/${id}`,
}

export const axiosUserEquipment = {
  get: (id) => axios.get(axiosUserEquipmentUrl.get(id)),
  createUpdate: (data) => axios.post(axiosUserEquipmentUrl.createUpdate, data),
  delete: (id) => axios.delete(axiosUserEquipmentUrl.delete(id)),
}

/*** Trash routes */
let trash_api_group = `/trash`
export const axiosTrashUrl = {
  list: `${trash_api_group}`,
  get: (id) => `${trash_api_group}/${id}`,
  trashedItems: `${trash_api_group}/trashed`,
  restore: `${trash_api_group}/restore`,
}
export const axiosTrash = {
  list: (params) => axios.get(axiosTrashUrl.list, {params}),
  get: (id) => axios.get(axiosTrashUrl.get(id)),
  trashedItems: (params) => axios.get(axiosTrashUrl.trashedItems, {params}),
  restore: (data) => axios.post(axiosTrashUrl.restore, data)
}

/**
 * Profile routes
 */
let profile_api_group = `/profile`
export const axiosProfileUrl = {
  profileImage: `${profile_api_group}/image`,
  profileImageDelete: `${profile_api_group}/delete-image`,
  updateGeneral: `${profile_api_group}/update/general`,
  updateProfile: `${profile_api_group}/update/profile`,
  dailyReport: `${profile_api_group}/report/daily`,
  timesheetPlan: `${profile_api_group}/report/timesheet`,
  deleteReport: `${profile_api_group}/report/delete`,
}
export const axiosProfile = {
  upload: (data) => axios.post(axiosProfileUrl.profileImage, data),
  deleteImage: () => axios.post(axiosProfileUrl.profileImageDelete),
  updateGeneral: (data) => axios.post(axiosProfileUrl.updateGeneral, data),
  updateProfile: (data) => axios.post(axiosProfileUrl.updateProfile, data),
  generateDailyReport: (data) => axios.post(axiosProfileUrl.dailyReport, data),
  generateTimesheetPlan: (data) => axios.post(axiosProfileUrl.timesheetPlan, data),
  deleteReport: (data) => axios.post(axiosProfileUrl.deleteReport, data),
}

/**
 * Site Updates
 */
let site_updates_api_group = `/site-updates`
export const siteUpdatesUrl = {
  uploadAndUpdateCategories: `${site_updates_api_group}/upload-and-update-categories`,
}
export const axiosSiteUpdates = {
  uploadAndUpdateCategories: (file) => {
    let form_data = new FormData
    form_data.append(`file`, file)
    return axios.post(
      siteUpdatesUrl.uploadAndUpdateCategories,
      form_data,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
  },
}

/**
 * Helper methods
 */
export const APPEND_RECURSIVE_FORM_DATA = (form_data, data, prefix = '') => {
  if (!data) return
  Object.entries(data).forEach(([key, val]) => {
    let name = key
    if (prefix) {
      name = `${prefix}[${key}]`
    }
    if (Array.isArray(val)) {
      val.forEach((val2, key2) => {
        APPEND_RECURSIVE_FORM_DATA(form_data, val2, `${name}[${key2}]`)
      })
    } else if (typeof val === 'object' && val !== null) {
      APPEND_RECURSIVE_FORM_DATA(form_data, val, name)
    } else {
      form_data.append(name, val)
    }
  })
}

export const ERROR_RESPONSE_MESSAGE = ({response}) => {
  let error_texts = extractValidatorErrors(response?.data?.errors || null);
  if (!error_texts.length) {
    error_texts = [response?.data?.message || response?.data?.error || i18n.t('error_groups.__code500')]
  }
  renderTextError(error_texts, response.status)
}

let extractValidatorErrors = (errors) => {
  let error_texts = [];
  let list = {
    fields: [],
    groups: []
  }
  if (!errors) return error_texts
  Object.keys(errors).forEach(el => {
    if (el.includes('.')) {
      let srt_parts = el.split('.')
      let group = srt_parts.shift()
      if (!group) return
      let field = srt_parts.reverse().shift()
      if (!list.fields[group]) {
        list.fields[group] = []
      }
      list.fields[group].push(field)
    } else {
      list.groups.push(el)
    }
  })
  if (!Object.keys(list.fields).length && !list.groups.length) return;
  list.groups.forEach(val => {
    error_texts.push(i18n.t(`form_fields.${val}`))
  })
  Object.entries(list.fields).forEach(([key, val]) => {
    error_texts.push(
      `${i18n.t(`error_groups.${key}`)}: ${val.map(el => `${i18n.t(`form_fields.${el}`)}`).join(', ')}`
    )
  })
  return error_texts
}

let renderTextError = (error_texts, code) => {
  let error_str = ''
  error_str += `<div><b>${i18n.t(`error_groups.__code`, {code: code})}</b></div>`
  if (code !== 500) {
    error_str += `<div><b>${i18n.t(`error_groups.__default`)}</b></div>`
    error_str += `<ul>${error_texts.map(error_text => `<li>${error_text}</li>`).join('')}</ul>`
  } else {
    error_str += `<div>${i18n.t('error_groups.__code500')}</div>`
  }

  vuex.dispatch('actionPushErrorMessage', error_str)
}
